export default "__VITE_ASSET__Sk9iqqNQ__"